// extracted by mini-css-extract-plugin
module.exports = {"Visual__Container":"Visual__Container_26s_","Visual__Prllx":"Visual__Prllx_3Sfr"};